// @ts-nocheck

import React, { useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { createOtherService } from "../../../features/otherServices"; // Assuming your action for room services
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const AddOtherService = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");

  const [formData, setFormData] = useState({
    title: "", // Room service name
    key: "", // Single description for the room service
    icon: null, // Image for the room service
    order_type: "",
  });

  const [imagePreview, setImagePreview] = useState(null); // For image preview

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        icon: e.target.files[0], // Handle photo image change
      }));
      setImagePreview(URL.createObjectURL(e.target.files[0])); // For image preview
    }
  };

  const handleSubmit = () => {
    // Dispatch createRoomService with formData
    const formDataFinal = new FormData();

    formDataFinal.append("language", language);
    formDataFinal.append("folder_name", "other_service");
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value);
      }
    });

    dispatch(createOtherService(formDataFinal))
      .then((resultAction) => {
        if (createOtherService.rejected.match(resultAction)) {
          // This means it was a rejection, handle error
          // toast.error("An error occurred while creating the Promotion.");
          console.error(resultAction.payload || resultAction.error);
        } else {
          toast.success("Other Service created successfully!");
          navigate("/other-services");
        }
      })
      .catch((err) => {
        // // // console.log(err, "error");
        toast.error("An error occurred while creating the room service.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Add Other Service
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Name Field */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                <MenuItem style={{ marginBottom: "5px" }} value="en">
                  English
                </MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="title"
              placeholder="Enter the service title"
              value={formData.title}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Description Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Key
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="key"
              placeholder="Enter the key"
              value={formData.key}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Order Type
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="order_type"
              placeholder="Enter The Order Type"
              value={formData.order_type}
              onChange={handleChange}
            />
          </SoftBox>

          <SoftBox mb={2} sx={{ display: "flex", alignItems: "center" }}>
            <input
              type="checkbox"
              name="is_visible"
              id="is_visible"
              checked={formData.is_visible}
              onChange={handleChange}
              style={{
                          marginRight: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                        }}F
            />
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              htmlFor="is_visible"
            >
              Is Visible
            </SoftTypography>
          </SoftBox>

          {/* Photo Field */}
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Icon
              </SoftTypography>
            </SoftBox>
            <input
              type="file"
              accept="image/*"
              name="icon"
              onChange={handleImageChange}
              style={{ width: "100%", padding:'10px', border:'1px solid #ccc', borderRadius:'5px'  }}
            />
            {imagePreview && (
              <img
                src={imagePreview}
                alt="Preview"
                style={{ width: "150px", height: "150px", marginTop: "20px" }}
              />
            )}
          </SoftBox>

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="final"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default AddOtherService;
